import { uuid25 } from "../../uuid/dist/uuid25.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/word.entity.ts
var createWord = (value) => deepMerge({
	id: uuid25(),
	name: "",
	abbreviation: "",
	englishName: "",
	description: "",
	synonyms: "",
	forbiddenWords: "",
	order: ""
}, value ?? {});
//#endregion
export { createWord };
